import { ref } from 'vue';

/**
 * @description 管理付费步骤
 * @author zyc
 * @lastEditor zyc
 * @lastEditTime 2022/3/30/14:38
 */
const initStep = () => {
    // 激活步骤
    const activeStep = ref(0);

    // 设置步骤
    const setActiveStep = (step: number) => {
        activeStep.value = step;
    };

    // 步骤-1
    const backStep = () => {
        if (activeStep.value !== 0) {
            activeStep.value -= 1;
        } else {
            // TODO 批量操作放回到home页
        }
    };

    return {
        activeStep,
        setActiveStep,
        backStep
    };
};
export default initStep;